/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchEmployees} from '../api'

export const useMutationSearchEmployees = createReactQueryMutationHook('searchEmployees', searchEmployees)
